// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Ty-Ze5QX2Ebmh0luFlElk","icon":"_3hf74gv3ysLPx_IGXR4u1L","link":"_3J7lxC9snmoM4MhszFDApE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/titleBar/titleBar.css
// module id = 1098
// module chunks = 0